import { render, staticRenderFns } from "./UserSkeleton.vue?vue&type=template&id=40d47deb&scoped=true&"
import script from "./UserSkeleton.vue?vue&type=script&lang=js&"
export * from "./UserSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./UserSkeleton.vue?vue&type=style&index=0&id=40d47deb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d47deb",
  null
  
)

export default component.exports